export const REQUEST_SINISTER = "@@SINISTER/REQUEST_SINISTER";
export const SUCCESS_SINISTER = "@@SINISTER/SUCCESS_SINISTER";
export const FAILURE_SINISTER = "@@SINISTER/FAILURE_SINISTER";

export const UPDATE_SINISTER_BODY = "@@SINISTER/UPDATE_SINISTER_BODY";

export const REQUEST_UPLOAD_PHOTO = "@@SINISTER/REQUEST_UPLOAD_PHOTO";
export const SUCCESS_UPLOAD_PHOTO = "@@SINISTER/SUCCESS_UPLOAD_PHOTO";
export const FAILURE_UPLOAD_PHOTO = "@@SINISTER/FAILURE_UPLOAD_PHOTO";

export const ADD_INJURED_PEOPLE = "@@SINISTER/ADD_INJURED_PEOPLE";
export const UPDATE_NUMERIC_ERRORS = "@@SINISTER/UPDATE_NUMERIC_ERRORS";
export const UPDATE_INJURED_PEOPLE = "@@SINISTER/UPDATE_INJURED_PEOPLE";
export const CLEAN_NUMERIC_ERRORS = "@@SINISTER/CLEAN_NUMERIC_ERRORS";
export const CLEAN_INJURED_PEOPLE = "@@SINISTER/CLEAN_INJURED_PEOPLE";

export const RESET = "@@SINISTER/RESET";

export default (state: any, action: any) => {
  switch (action.type) {
    case REQUEST_SINISTER:
      return {
        ...state,
        loading: true,
        errors: {},
        success: {},
      };

    case SUCCESS_SINISTER:
      return {
        ...state,
        success: {
          sinister: action.payload,
        },
        injured_people: [],
        errors: {},
        loading: false,
        refresh: true,
      };

    case FAILURE_SINISTER:
      return {
        ...state,
        errors: {
          sinister: action.payload,
        },
        success: {},
        injured_people: [],
        loading: false,
        refresh: true,
      };

    case REQUEST_UPLOAD_PHOTO:
      const image_preview = [...state.image_preview];
      image_preview.push(action.payload);
      return {
        ...state,
        image_preview,
        loading: true,
        errors: {},
        success: {},
      };

    case SUCCESS_UPLOAD_PHOTO:
      return {
        ...state,
        success: {
          photo: action.payload,
        },
        errors: {},
        loading: false,
      };

    case FAILURE_UPLOAD_PHOTO:
      return {
        ...state,
        errors: {
          photo: action.payload,
        },
        success: {},
        loading: false,
      };

    case UPDATE_SINISTER_BODY:
      return {
        ...state,
        errors: {},
        success: {},
        sinister_body: {
          ...state.sinister_body,
          ...action.payload,
        },
      };

    case ADD_INJURED_PEOPLE:
      const injured_people_array = state.injured_people;
      injured_people_array.push(action.payload);
      return {
        ...state,
        injured_people: injured_people_array,
      };

    case UPDATE_INJURED_PEOPLE:
      const new_injured = state.injured_people;
      new_injured[action.payload.index] = action.payload.value;
      return {
        ...state,
        injured_people: new_injured,
      };

    case UPDATE_NUMERIC_ERRORS:
      return {
        ...state,
        numeric_errors: [...state.numeric_errors, ...action.payload],
      };

    case CLEAN_INJURED_PEOPLE:
      return {
        ...state,
        injured_people: [],
      };

    case CLEAN_NUMERIC_ERRORS:
      return {
        ...state,
        numeric_errors: [],
      };

    case RESET:
      return {
        success: {},
        errors: {},
        sinister_body: {},
        image_preview: [],
        loading: false,
      };

    default:
      return state;
  }
};
